<!-- 查询月票账号交易记录 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props: ['commonUrls'],
    data() {
        return {
            requestBody: {

            },
            responseCode: {
                "data": {
                    "monthTicketList": [
                        {

                        }
                    ],
                    "total": 1
                }, "message": "业务成功", "resultCode": 0, "status": 1
            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台查询月票账号扣费记录",
                t_url: this.commonUrls.test + "getMonthTicketAccountUseRecord",
                p_url: this.commonUrls.prod + "getMonthTicketAccountUseRecord",
                precondition: "无",
                fitSystem: "智汇云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'monthTicketBillId', info2: '是', info3: 'Integer', info4: '月票订单Id' },
                        { info1: 'operatorTimeStart', info2: '否', info3: 'String', info4: '交易时间开始，yyyyMMddHHmmss' },
                        { info1: 'operatorTimeEnd', info2: '否', info3: 'String', info4: '交易时间结束，yyyyMMddHHmmss' },
                        { info1: 'pageNum', info2: '是', info3: 'Integer', info4: '第几页，从1开始' },
                        { info1: 'pageSize', info2: '是', info3: 'Integer', info4: '每页多少条，最多1000条' }
                    ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'recordList', info2: '是', info3: 'JSONArray', info4: '数据列表' },
                        { info1: 'currCount', info2: '是', info3: 'Integer', info4: '当前记录数' },
                        { info1: 'total', info2: '是', info3: 'Integer', info4: '总数' },
                    ]
                },{
                    titleName: 'recordList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                      { info1: 'ownerName', info2: '是', info3: 'String', info4: '人员姓名' },
                      { info1: 'ownerPhone', info2: '是', info3: 'String', info4: '人员手机号' },
                      { info1: 'deductionValue', info2: '是', info3: 'Decimal', info4: '扣减值' },
                      { info1: 'deductionValueDesc', info2: '否', info3: 'String', info4: '扣减值描述' },
                      { info1: 'previousBalance', info2: '是', info3: 'Decimal', info4: '扣减前余额' },
                      { info1: 'previousBalanceDesc', info2: '否', info3: 'String', info4: '扣减前余额描述' },
                      { info1: 'endingBalance', info2: '是', info3: 'Decimal', info4: '扣减后余额' },
                      { info1: 'endingBalanceDesc', info2: '否', info3: 'String', info4: '扣减后余额描述' },
                      { info1: 'carCode', info2: '是', info3: 'String', info4: '车牌号' },
                      { info1: 'plateColor', info2: '是', info3: 'Integer', info4: '车牌颜色' },
                      { info1: 'monthTicketName', info2: '是', info3: 'String', info4: '月票名称' },
                      { info1: 'enterTime', info2: '是', info3: 'String', info4: '进场时间，yyyyMMddHHmmss' },
                      { info1: 'leaveTime', info2: '是', info3: 'String', info4: '离场时间，yyyyMMddHHmmss' },
                      { info1: 'remark', info2: '否', info3: 'String', info4: '备注' },
                      { info1: 'parkName', info2: '是', info3: 'String', info4: '车场名称' }
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/ticket/getMonthTicketAccountUseRecord.vue